/**
 * Created by rickborst on 22/02/2017.
 *
 * Used methods from: http://www.quirksmode.org/js/cookies.html#script
 */

/**
 * Writes a value to cookie storage under a given name.
 *
 * @param {string} name - Storage name.
 * @param {string} value - Value string.
 * @param {number} [days] - Days until expiry.
 */
export function write (name, value, days = 366) {
    let date = new Date(),
        expires;

    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toGMTString();

    document.cookie = name + '=' + value + expires + '; path=/';
}

/**
 * Reads a value from cookie storage under a given name.
 *
 * @param {string} name - Storage name.
 * @returns {string|null} Cookie value.
 */
export function read (name) {
    let nameEQ = name + '=',
        ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }

    return null;
}

/**
 * Clears a value from cookie storage under a given name.
 *
 * @param {string} name - Storage name.
 */
export function clear (name) {

    write(name, '', -1);
}


// WEBPACK FOOTER //
// ./src/js/storage/manager/cookie.js